import React, { Component } from 'react';
import Validator from 'validatorjs';

import { FormControl } from '../../../../facturotopia';

class UuidForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      validator: new Validator({}, this.rules({})),
    };
  }

  rules(data) {
    return {
      id: ['string', 'min:36', 'max:36'],
    };
  }

  handleOnChange = (value) => {
    const data = {
      ...this.props.data,
      ...value,
    };

    const validator = this.validate(data);

    this.props.onFormDataChange({
      data,
      isValid: validator.passes(),
    });
  };

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    return validator;
  }

  render() {
    const { data } = this.props;
    const rule = this.rules(data);

    return (
      <FormControl
        type="text"
        label="Id del emisor"
        name="id"
        minLength="36"
        maxLength="36"
        placeholder="xxxxxxxx-xxxx-zxxx-yxxx-xxxxxxxxxxxx"
        help="UUID del emisor en el sistema"
        value={data.id}
        rules={rule.id}
        onChange={this.handleOnChange}
      />
    );
  }
}

export default UuidForm;
